import { useCallback, useContext } from 'react';
import AlertsContext from '~/context/common/AlertsContext';
import useIsInFavoritesAndSavedSearchExperiment from '~/hooks/common/useIsInFavoritesAndSavedSearchExperiment';
import FavoritesToastContent from './FavoritesToastContent';
import styles from './FavoritesToastContent.module.css';
import { ToastAction, ToastView } from './types';

const useDisplayFavoritesToast = () => {
  const { showToast } = useContext(AlertsContext);
  const isInFavoritesAndSavedSearchExperiment =
    useIsInFavoritesAndSavedSearchExperiment();

  return useCallback(
    (action: ToastAction, view?: ToastView) => {
      if (!isInFavoritesAndSavedSearchExperiment) return;

      return showToast({
        className: styles.favoriteToast,
        label: <FavoritesToastContent action={action} view={view} />,
        lifetime: 6000,
        position: 'top-center',
        severity: 'custom',
        showClose: false
      });
    },
    [isInFavoritesAndSavedSearchExperiment, showToast]
  );
};

export default useDisplayFavoritesToast;
